import { DebugService } from './debug.service';

export class _HostAppEventsService {
  debug: DebugService;

  constructor() {
    this.debug = new DebugService('HostAppEventsService');
  }

  sendNextStepEvent(step) {
    document.dispatchEvent(
      new CustomEvent('next-step', {
        bubbles: true,
        composed: true,
        detail: {
          step,
          sentFrom: 'lienholder',
        },
      })
    );
  }

  sendNextMfeEvent() {
    document.dispatchEvent(
      new CustomEvent('next-mfe', {
        bubbles: true,
        composed: true,
        detail: {
          sentFrom: 'lienholder',
        },
      })
    );
  }

  hideLoaderSpinnerEvent() {
    document.dispatchEvent(
      new CustomEvent('hide-loader-spinner', {
        bubbles: true,
        composed: true,
      })
    );
  }
}

export const HostAppEventsService = new _HostAppEventsService();
